import { useState } from "react";
import { Sparkles } from "lucide-react";

export const GratitudeChips = ({ label, phrases, testPrefix }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="pp-gratitude" data-testid={`${testPrefix}-chips`}>
      <p className="pp-gratitude-label"><Sparkles className="h-4 w-4" /> {label}</p>
      {open ? (
        <>
          <ul className="pp-gratitude-ideas" data-testid={`${testPrefix}-ideas`}>
            {phrases.map((p) => <li key={p}>“{p.trim()}{p.endsWith(" ") ? "…" : ""}”</li>)}
          </ul>
          <p className="text-xs opacity-70 mt-1">Remember it, then say it or write it in your own words.</p>
        </>
      ) : (
        <button type="button" className="pp-pill gold" onClick={() => setOpen(true)} data-testid={`${testPrefix}-reveal`}>
          Need an idea?
        </button>
      )}
    </div>
  );
};
